import BpkBadge, { BADGE_TYPES } from '@skyscanner-internal/backpack-web/bpk-component-badge';
import { withRtlSupport } from '@skyscanner-internal/backpack-web/bpk-component-icon';
import BpkSmallTrendIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/trend';
import BpkSmallTrendDownIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/trend--down';
import BpkSmallTrendSteadyIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/trend--steady';
import { useTranslations } from '@web-platform/shared-travel-tools-utils-frontend';

import type { BadgeType } from '@skyscanner-internal/backpack-web/bpk-component-badge/src/BpkBadge';

import STYLES from './PriceBadge.module.scss';

const BpkSmallTrendDownIconWithRtl = withRtlSupport(BpkSmallTrendDownIcon);
const BpkSmallTrendSteadyIconWithRtl = withRtlSupport(BpkSmallTrendSteadyIcon);
const BpkSmallTrendIconWithRtl = withRtlSupport(BpkSmallTrendIcon);

const PRICE_LEVEL_CONFIG: Record<string, { icon: React.ReactNode; badgeType: BadgeType }> = {
  PRICE_LEVEL_LOW: {
    icon: <BpkSmallTrendDownIconWithRtl aria-hidden />,
    badgeType: BADGE_TYPES.success,
  },
  PRICE_LEVEL_TYPICAL: {
    icon: <BpkSmallTrendSteadyIconWithRtl aria-hidden />,
    badgeType: BADGE_TYPES.normal,
  },
  PRICE_LEVEL_HIGH: {
    icon: <BpkSmallTrendIconWithRtl aria-hidden />,
    badgeType: BADGE_TYPES.critical,
  },
};

type Props = {
  priceLevel: string;
  priceDifferencePercentage: number;
};

export const PriceBadge = ({ priceDifferencePercentage, priceLevel }: Props) => {
  const { translate } = useTranslations();

  const config = PRICE_LEVEL_CONFIG[priceLevel];

  if (!config) {
    return null;
  }

  let label;

  if (priceLevel === 'PRICE_LEVEL_TYPICAL') {
    label = translate('travel_confidence_map_price_as_expected');
  } else if (priceLevel === 'PRICE_LEVEL_LOW') {
    label = translate('travel_confidence_map_price_cheaper', {
      percent: priceDifferencePercentage,
    });
  } else {
    label = translate('travel_confidence_map_price_more_expensive', {
      percent: priceDifferencePercentage,
    });
  }

  return (
    <BpkBadge type={config.badgeType} className={STYLES.badge}>
      {config.icon}
      {label}
    </BpkBadge>
  );
};
